import { Link } from 'react-router-dom';
import { latestUpdates, comics, categories } from '@/mocks/comics';

export default function UpdateSection() {
  const updates = latestUpdates.map((u) => {
    const comic = comics.find((c) => c.id === u.comicId)!;
    return { ...u, comic };
  });

  return (
    <section className="py-12 md:py-16">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-end justify-between mb-8">
            <div>
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                最新更新
              </h2>
              <p className="text-sm text-foreground-500 mt-1">实时追踪最新话更新</p>
            </div>
            <Link
              to="/category/hanman"
              className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap"
            >
              更多更新
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="bg-background-100/70 rounded-xl p-5 md:p-6">
            <div className="space-y-1">
              {updates.map((item, idx) => (
                <Link
                  key={`${item.comicId}-${item.chapter}`}
                  to={`/comic/${item.comicId}`}
                  className="flex items-center gap-4 px-4 py-3 rounded-lg hover:bg-background-50 transition-colors group"
                >
                  <span className={`text-sm font-bold w-8 h-8 flex items-center justify-center rounded-lg flex-shrink-0 ${
                    idx < 3
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-200 text-foreground-500'
                  }`}>
                    {idx + 1}
                  </span>
                  <div className="w-10 h-14 rounded overflow-hidden flex-shrink-0 bg-background-200">
                    <img
                      src={item.comic.cover}
                      alt={item.comic.title}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h4 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                      {item.comic.title}
                    </h4>
                    <p className="text-xs text-foreground-500 mt-0.5">
                      {item.chapter} - {item.title}
                    </p>
                  </div>
                  <div className="flex items-center gap-3 flex-shrink-0">
                    <span className="text-xs px-2 py-0.5 rounded bg-accent-100 text-accent-700 whitespace-nowrap">
                      {categories.find((c) => c.slug === item.comic.category)?.name}
                    </span>
                    <span className="text-xs text-foreground-400 hidden sm:block whitespace-nowrap">
                      {item.date}
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}